// Country code to country name mapping
const COUNTRY_NAMES = {
  ZA: 'South Africa',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  US: 'United States',
  GB: 'United Kingdom',
  CA: 'Canada',
  AU: 'Australia',
  DE: 'Germany',
  FR: 'France',
  IT: 'Italy',
  ES: 'Spain',
  NL: 'Netherlands',
  BE: 'Belgium',
  CH: 'Switzerland',
  AT: 'Austria',
  SE: 'Sweden',
  NO: 'Norway',
  DK: 'Denmark',
  FI: 'Finland',
  IE: 'Ireland',
  PT: 'Portugal',
  GR: 'Greece',
  PL: 'Poland',
  CZ: 'Czech Republic',
  HU: 'Hungary',
  RO: 'Romania',
  BG: 'Bulgaria',
  HR: 'Croatia',
  SI: 'Slovenia',
  SK: 'Slovakia',
  LT: 'Lithuania',
  LV: 'Latvia',
  EE: 'Estonia',
  CY: 'Cyprus',
  MT: 'Malta',
  LU: 'Luxembourg',
  IS: 'Iceland',
  LI: 'Liechtenstein',
  MC: 'Monaco',
  SM: 'San Marino',
  VA: 'Vatican City',
  AD: 'Andorra',
  BR: 'Brazil',
  AR: 'Argentina',
  CL: 'Chile',
  CO: 'Colombia',
  MX: 'Mexico',
  PE: 'Peru',
  UY: 'Uruguay',
  PY: 'Paraguay',
  BO: 'Bolivia',
  EC: 'Ecuador',
  VE: 'Venezuela',
  GY: 'Guyana',
  SR: 'Suriname',
  GF: 'French Guiana',
  FK: 'Falkland Islands',
  GS: 'South Georgia and the South Sandwich Islands',
  JP: 'Japan',
  KR: 'South Korea',
  CN: 'China',
  IN: 'India',
  TH: 'Thailand',
  SG: 'Singapore',
  MY: 'Malaysia',
  ID: 'Indonesia',
  PH: 'Philippines',
  VN: 'Vietnam',
  TW: 'Taiwan',
  HK: 'Hong Kong',
  MO: 'Macau',
  MN: 'Mongolia',
  KZ: 'Kazakhstan',
  UZ: 'Uzbekistan',
  KG: 'Kyrgyzstan',
  TJ: 'Tajikistan',
  TM: 'Turkmenistan',
  AF: 'Afghanistan',
  PK: 'Pakistan',
  BD: 'Bangladesh',
  LK: 'Sri Lanka',
  MV: 'Maldives',
  NP: 'Nepal',
  BT: 'Bhutan',
  MM: 'Myanmar',
  LA: 'Laos',
  KH: 'Cambodia',
  BN: 'Brunei',
  TL: 'East Timor',
  FJ: 'Fiji',
  PG: 'Papua New Guinea',
  NC: 'New Caledonia',
  VU: 'Vanuatu',
  SB: 'Solomon Islands',
  TO: 'Tonga',
  WS: 'Samoa',
  KI: 'Kiribati',
  TV: 'Tuvalu',
  NR: 'Nauru',
  PW: 'Palau',
  FM: 'Micronesia',
  MH: 'Marshall Islands',
  NZ: 'New Zealand',
  EG: 'Egypt',
  LY: 'Libya',
  TN: 'Tunisia',
  DZ: 'Algeria',
  MA: 'Morocco',
  SD: 'Sudan',
  SS: 'South Sudan',
  ET: 'Ethiopia',
  ER: 'Eritrea',
  DJ: 'Djibouti',
  SO: 'Somalia',
  KE: 'Kenya',
  UG: 'Uganda',
  TZ: 'Tanzania',
  RW: 'Rwanda',
  BI: 'Burundi',
  MW: 'Malawi',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  BW: 'Botswana',
  NA: 'Namibia',
  SZ: 'Eswatini',
  LS: 'Lesotho',
  MG: 'Madagascar',
  MU: 'Mauritius',
  SC: 'Seychelles',
  KM: 'Comoros',
  YT: 'Mayotte',
  RE: 'Réunion',
  MZ: 'Mozambique',
  AO: 'Angola',
  CD: 'Democratic Republic of the Congo',
  CG: 'Republic of the Congo',
  CF: 'Central African Republic',
  TD: 'Chad',
  CM: 'Cameroon',
  GQ: 'Equatorial Guinea',
  GA: 'Gabon',
  ST: 'São Tomé and Príncipe',
  GH: 'Ghana',
  TG: 'Togo',
  BJ: 'Benin',
  NE: 'Niger',
  BF: 'Burkina Faso',
  ML: 'Mali',
  SN: 'Senegal',
  GM: 'Gambia',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  SL: 'Sierra Leone',
  LR: 'Liberia',
  CI: 'Ivory Coast',
  MR: 'Mauritania',
  CV: 'Cape Verde',
  NG: 'Nigeria',
  RU: 'Russia',
  BY: 'Belarus',
  UA: 'Ukraine',
  MD: 'Moldova',
  GE: 'Georgia',
  AM: 'Armenia',
  AZ: 'Azerbaijan',
  TR: 'Turkey',
  IQ: 'Iraq',
  IR: 'Iran',
  SY: 'Syria',
  LB: 'Lebanon',
  JO: 'Jordan',
  IL: 'Israel',
  PS: 'Palestine',
  KW: 'Kuwait',
  QA: 'Qatar',
  BH: 'Bahrain',
  OM: 'Oman',
  YE: 'Yemen',
};

// Helper function to normalize country names (replace underscores with spaces)
const normalizeCountryName = countryName => {
  if (!countryName) return countryName;
  return countryName.replace(/_/g, ' ');
};

// Helper to compare country names case-insensitively with underscore normalization
const isCountryMatch = (countryName, targetCountryUpper) => {
  if (!countryName) return false;
  const normalized = normalizeCountryName(countryName).toUpperCase();
  return normalized === targetCountryUpper;
};

// Function to show full page location loader
const showLocationLoader = () => {
  // Check if loader already exists
  const existingLoader = document.getElementById('location-loader');
  if (existingLoader) {
    return; // Don't create duplicate
  }

  // Create loader element
  const loader = document.createElement('div');
  loader.id = 'location-loader';
  loader.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(26, 26, 26, 0.95);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    z-index: 1000;
    backdrop-filter: blur(5px);
  `;

  loader.innerHTML = `
    <div style="text-align: center;">
      <div style="margin-bottom: 1rem; font-size: 2rem;">🌍</div>
      <div>Detecting your location...</div>
    </div>
  `;

  // Add to body
  document.body.appendChild(loader);
};

// Function to remove location loader
const removeLocationLoader = () => {
  const loader = document.getElementById('location-loader');
  if (loader) {
    loader.remove();
  }
};

// Location detection utility for International redirection
export const detectUserLocation = async () => {
  try {
    // First try to get location from IP geolocation
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    if (data.country_code === 'ZA') {
      return normalizeCountryName('SOUTH_AFRICA');
    } else if (data.country_code && COUNTRY_NAMES[data.country_code]) {
      return COUNTRY_NAMES[data.country_code];
    } else {
      return 'INTERNATIONAL';
    }
  } catch (error) {
    try {
      // Alternative IP geolocation service
      const response2 = await fetch('https://ipinfo.io/json');
      const data2 = await response2.json();

      if (data2.country === 'ZA') {
        return normalizeCountryName('SOUTH_AFRICA');
      } else if (data2.country && COUNTRY_NAMES[data2.country]) {
        return COUNTRY_NAMES[data2.country];
      } else {
        return 'INTERNATIONAL';
      }
    } catch (error2) {
      // Fallback to browser locale
      const locale = navigator.language || navigator.userLanguage;
      if (locale.includes('en-ZA') || locale.includes('ZA')) {
        return normalizeCountryName('SOUTH_AFRICA');
      } else {
        return 'INTERNATIONAL';
      }
    }
  }
};

export const shouldRedirectToInternational = async () => {
  const location = await detectUserLocation();
  // Redirect to international if the main app is unavailable in this country
  return !(
    isCountryMatch(location, 'NIGERIA') ||
    isCountryMatch(location, 'SOUTH AFRICA') ||
    isCountryMatch(location, 'KENYA')
  );
};

// Keep the old function name for backward compatibility
export const shouldRedirectToUAE = shouldRedirectToInternational;

export const getUserCountry = async () => {
  return await detectUserLocation();
};

// Login redirection utility based on user country
export const handleLoginRedirect = async () => {
  // Show full page loader
  showLocationLoader();

  try {
    // Always detect location on click (no session storage caching)
    const userCountry = await detectUserLocation();

    // Check if the main app is available in the user's country
    if (
      isCountryMatch(userCountry, 'NIGERIA') ||
      isCountryMatch(userCountry, 'SOUTH AFRICA') ||
      isCountryMatch(userCountry, 'KENYA')
    ) {
      // Redirect users in available countries to login
      window.location.href = 'https://app.edcsquared.io/login';
    } else {
      // Redirect to international page for all other countries
      window.location.href = '/international';
    }
  } catch (error) {
    // Remove loader on error
    removeLocationLoader();
    // Fallback: redirect to international page if location detection fails
    window.location.href = '/international';
  }
};

// Signup redirection utility based on user country
export const handleSignupRedirect = async () => {
  // Show full page loader
  showLocationLoader();

  try {
    // Always detect location on click (no session storage caching)
    const userCountry = await detectUserLocation();

    // Check if the main app is available in the user's country
    if (
      isCountryMatch(userCountry, 'NIGERIA') ||
      isCountryMatch(userCountry, 'SOUTH AFRICA') ||
      isCountryMatch(userCountry, 'KENYA')
    ) {
      // Redirect users in available countries to signup
      window.location.href = 'https://app.edcsquared.io/signup';
    } else {
      // Redirect to international page for all other countries
      window.location.href = '/international';
    }
  } catch (error) {
    // Remove loader on error
    removeLocationLoader();
    // Fallback: redirect to international page if location detection fails
    window.location.href = '/international';
  }
};
